import { beads, Bead } from '../beads.js';
import { settings } from '../settings.js';
import { modes } from '../modes.js';

export const tri = {};

tri.getTriangleOrder = () => {
    beads.arr.forEach(bead => {
        if (bead.tri !== undefined && bead.ignore !== true) {
            bead.tri.relative = {
                x: bead.tri.row - (settings.rows * 2),
                y: bead.tri.column - settings.rows
            };
        }
    });
};

tri.apply = (bead, i) => {
    if (i === 0) {
        if (settings.rows > 25) settings.rows = 25;
        tri.rowLengths = [];
        for (let i = 0; i < (settings.rows * 2) - 3; i++) {
            tri.rowLengths.push(Math.floor((i+3)/2));
        }
        tri.rowLengths.push(settings.rows);
        for (let i = (settings.rows * 2) - 2; i >= 0; i--) {
            tri.rowLengths.push(Math.floor((i + 3) / 2));
        }

        tri.point = {x: (38 * settings.rows) + 129, y: (64 * settings.rows) + 36};
        tri.mirrorPoint = {
            x: tri.point.x + (300 * (settings.rows / 15)),
            y: tri.point.y - (300 * (settings.rows / 15))
        };

        tri.row = 0;
        tri.column = 1;
        tri.panel = 0;

    };

    if (tri.panel >= 3) {
        bead.ignore = true;
    } else {
        bead.x = 100 + (tri.column * 38) - (19 * (tri.row % 2)) + (Math.abs((settings.rows * 2) - tri.row) * 0.8) - 8;
        bead.y = 100 + (tri.row * 32);

        bead.tri = {
            row: tri.row,
            column: tri.column,
            panel: 2-tri.panel
        };

        let angle = (Math.PI * (2/3) * tri.panel) - (Math.PI * 1/6);

        let x1 = bead.x - tri.point.x;
        let y1 = bead.y - tri.point.y;

        let x2 = x1 * Math.cos(angle) - y1 * Math.sin(angle);
        let y2 = y1 * Math.cos(angle) + x1 * Math.sin(angle);

        bead.x = x2 + tri.point.x + (300 * (settings.rows / 15));
        bead.y = y2 + tri.point.y - (300 * (settings.rows / 15));
        bead.setAngle(angle * (180 / Math.PI));

        if (tri.column == tri.rowLengths[tri.row]) {
            tri.column = 1;
            tri.row++;
        } else {
            tri.column++;
        }
        if (tri.row == tri.rowLengths.length) {
            tri.row = 0;
            tri.panel++;
        }
    }
};

const alterProject = () => {
    beads.tempArray = beads.arr
        .filter(bead => !bead.ignore)
        .map(bead => ({
            rx: bead.tri.relative?.x,
            ry: bead.tri.relative?.y,
            panel: bead.tri.panel,
            style: bead.style
    }));
};

const findTriangleMirrorBead = bead => {
    let result = [];
    beads.arr.forEach(_bead => {
        if (_bead.tri !== undefined) {
            if (_bead.tri.row == bead.tri.row && (_bead.tri.column == bead.tri.column)) {
                result.push(_bead);
            }
        }
        let halfway = 2 * (settings.rows - 1);
        let dist = halfway - bead.tri.row;
        if (_bead.tri !== undefined) {
            if (_bead.tri.row - dist == halfway && (_bead.tri.column == bead.tri.column)) {
                result.push(_bead);
            }
        }
    })
    return result;
};

const rotateMirror = () => {
    beads.mirror.forEach((mirror) => mirror.setAngle(0));
    beads.mirror.active = false;
    beads.mirror.forEach((mirror) => mirror.setAlpha(0));
    beads.mirror.orientation = 'vertical';
    modes.start('draw');
};

export const triangleConfig = {
    name: 'triangle',
    displayName: 'Triangle',
    colDist: () => 38,
    rowDist: () => 32,
    offset: () => -19,
    offsetPattern: [0, 1],
    apply: () => {
        beads.arr.forEach((bead, i) => {
            tri.apply(bead, i);
        });

        tri.getTriangleOrder();
    },
    create: () => {
        let n = settings.rows;
        let beadsNeeded = (6 * n * n) + 3 * n;
        for (let i = 0; i < beadsNeeded; i++) {
            let j = Math.floor(i / 10);
            beads.arr.push(new Bead(j, i));
        }
    },
    commutes: false,
    canSelectCommute: false,
    plastic: false,
    canSelectDirection: false,
    canSelectStartingBead: false,
    canSelectPanelWidth: false,
    canExportSmallDiagrams: false,
    beadFromPoint: true,
    noCustomBeadSize: true,
    noColumns: true,
    rowLimit: 25,
    noChangePattern: true,
    noDrag: true,
    noGuides: true,
    getDimensions: (myRows, myColumns, diameter, beadLength) => {
        return {
            width: myRows * beadLength * 0.376,
            height: myRows * beadLength * 0.4235
        };
    },
    getExportImageDimensions: rows => {
        let max = Math.max(settings.rows, 4);
        return {
            width: 2500 * (max/15),
            height: 2500 * (max/15)
        }
    },
    getBeadingModeStartingPosition: ({bead}) => [settings.rows, null],
    disabledTools: ['Row Shift', 'Paint', 'Star'],
    getRowsAndColumns: ({rows, columns, size}) => {
        rows = size;
        columns = 0; // not used
        return [rows, columns];
    },
    useSingleRenderTexture: false,
    useFourRenderTextures: true,
    noCoordinates: true,
    manualFindBead: true,
    alterProject,
    specialMirror: true,
    startMirror: () => {
        beads.mirror.forEach(mirror => {
            mirror.setX(tri.mirrorPoint.x);
            mirror.setY(tri.mirrorPoint.y);
        });
        [0, 150, 120].forEach((num, i) => beads.mirror[i].setAngle(num).setAlpha(1));
        beads.mirror.active = true;
    },
    findMirrorBead: findTriangleMirrorBead,
    alwaysShowLetterCodesOnExport: true,
    getRTLocation() {
        let x = (settings.rows > 10) ?
            (50 * (settings.rows / 20)):
            (100 * (settings.rows / 15) + 50);
        if (settings.rows === 8) x -= 30;
        if (settings.rows === 9) x -= 50;
        if (settings.rows === 10) x -= 80;

        return [x, 0];
    },
    doBeadingKey: 'triangle',
    advanceBeadingKey: 'advanceTriangle',
    getStripsKey: 'getTriangleStrips',
    getWordChartKey: 'getTriangleWordChart',
    noDiagrams: true,
    getImportedBead: ({bead}) => {
        if (bead.ignore) return;
        if (!bead.tri?.relative) return;
        return beads.tempArray.find(element =>
            element.rx === bead.tri.relative.x &&
            element.ry === bead.tri.relative.y &&
            element.panel === bead.tri.panel
        );
    },
    rotateMirror,
    arrangeGrid: false
};